<template>
  <span>
    <span v-for="(node, n) in nodes" :key="'word_' + n">
      <label-text v-if="n % 2" :to="node"></label-text>
      <template v-else>
        <nl2br tag="span" :text="node" />
      </template>
    </span>
  </span>
</template>

<script>
import label from './BankLabel'
import Nl2br from 'vue-nl2br'
export default {
  props: {
    text: [String],
    truncate: {
      type: Number,
      default: 0
    }
  },
  components: {
    'label-text': label,
    Nl2br
  },
  computed: {
    nodes: function () {
      var text = this.text
      if (this.truncate != 0) {
        text = this.$options.filters.truncate(text, this.truncate)
      }
      try {
        var querystr = /[0-9][0-9\-\–\s]*[0-9]+/
        var regex = new RegExp(querystr, 'gi')
        text = text.replace(regex, function (str) {
          return ';;' + str + ';;'
        })
        return text.split(';;')
      } catch (error) {
        return []
      }
    }
  }
}
</script>
